// extracted by mini-css-extract-plugin
module.exports = {"chip":"useCustomTagsStyles_chip__K_SbH"};